import { RegisterDog } from "container/OnBoarding/RegisterDog";
import React, { memo } from "react";
import Loader from "shared/Components/loader";

const DogsProfile = React.forwardRef(
  ({ isEditable = true, data, loading, onRemoveLoader }, ref) => {
    return loading ? (
      <Loader />
    ) : (
      <RegisterDog
        isEditable={isEditable}
        ref={ref}
        isProfile={true}
        dogsState={data ? data?.getMyRegisteredDogs : []}
        onRemoveLoader={onRemoveLoader}
      />
    );
  }
);

export default memo(DogsProfile);
